import { NavigationDrawerV2 } from '../NavigationDrawerV2';

export function NavigationDrawer() {
  return <NavigationDrawerV2 />;
}
